import { environment } from '@env/environment';

/**
 * Kept as `GlobalConfig` so ported call sites read exactly as they did in the
 * React app (`GlobalConfig.KEY_TOKEN`, `GlobalConfig.URL_API`, ...).
 */
export const GlobalConfig = environment;
